import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup, Typography } from "@mui/material"
import language from "../../../../language/language"
import { useContext } from "react"
import { LanguageContext } from "../../../../utilities/contexts/LanguageContext"
import CloseIcon from '@mui/icons-material/Close'
import { stopAutoDispatchStyles } from "./StopAutoDispatchModalStyles"

type StopAutoDispatchModalProps = {
    openDialog: boolean,
    handleCloseDialog: () => void,
    selectedReason: any,
    setSelectedReason: (value: any) => void,
    handleConfirmStopAutoDispatch: () => void
}

export const StopAutoDispatchModal = ({
    openDialog,
    handleCloseDialog,
    selectedReason,
    setSelectedReason,
    handleConfirmStopAutoDispatch
}: StopAutoDispatchModalProps) => {

    const handleReasonChange = (event: { target: { value: React.SetStateAction<string> } }): void => {
        setSelectedReason(event.target.value)
    }

    const { currentLanguage } = useContext(LanguageContext)
    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="xs" // Change this value to control the maximum width
            fullWidth
            sx={stopAutoDispatchStyles.dialogSize} // Custom width
        >
            <DialogTitle sx={stopAutoDispatchStyles.dialogTitle}>
                {language[currentLanguage].stopDispatchNow}
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={stopAutoDispatchStyles.closeIcon}>
                    <CloseIcon sx={stopAutoDispatchStyles.closeIconImg} />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={stopAutoDispatchStyles.dialogContentText}>
                    {language[currentLanguage].stopAutoDispatchDialogSubText}
                </DialogContentText>
                <FormLabel>Reason (required)</FormLabel>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="reason"
                        name="reason"
                        value={selectedReason}
                        onChange={handleReasonChange}>
                        <FormControlLabel
                            value="Customer address hard to find"
                            control={<Radio />}
                            label={language[currentLanguage].reasonCustomerAddress}
                        />
                        <FormControlLabel
                            value="Cash customer"
                            control={<Radio />}
                            label={language[currentLanguage].reasonCashCustomer}
                        />
                        <FormControlLabel
                            value="Hazardous materials"
                            control={<Radio />}
                            label={language[currentLanguage].reasonHazardMaterials}
                        />
                        <FormControlLabel
                            value="Transfer part"
                            control={<Radio />}
                            label={language[currentLanguage].reasonTransferPart}
                        />
                        <FormControlLabel
                            value="Part doesn't meet size specifications"
                            control={<Radio />}
                            label={
                                <>
                                    {' '}
                                    {language[currentLanguage].reasonPartSpecs}
                                    <Typography variant="body2" color="textSecondary">
                                        {' '}
                                        {language[currentLanguage].subReasnPartSpecs}
                                    </Typography>{' '}
                                </>
                            }
                        />
                        <FormControlLabel
                            value="System error"
                            control={<Radio />}
                            label={language[currentLanguage].reasonSystemError}
                        />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions sx={stopAutoDispatchStyles.dialogActions}>
                <Button
                    onClick={handleCloseDialog}
                    color="primary"
                    variant="outlined"
                    sx={stopAutoDispatchStyles.cancelButton}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmStopAutoDispatch}
                    color="primary"
                    variant="contained"
                    data-testid='auto-dispatch'
                    disabled={!selectedReason}
                    sx={stopAutoDispatchStyles.stopAutoDispatchButton}>
                    Stop Autodash
                </Button>
            </DialogActions>
        </Dialog>
    )
}